import { openAgencyEmailSignInModal } from "../../../../components/molecules/modals/ats/public-sign-in-modal.tsx/agency-email-sign-in-modal";
import { useAmILoggedInAgencyContact } from "../../../api-docs";
import { EmailSignInButton } from "../../components/email-sign-in-button";

export const AgencySelfApplySignInButton = () => {
  const isLoggedIn = useAmILoggedInAgencyContact();
  return (
    <EmailSignInButton
      isAgencyContact={true}
      isLoggedIn={
        isLoggedIn?.data?.success
          ? {
              email: isLoggedIn?.data?.email,
            }
          : undefined
      }
      onClick={openAgencyEmailSignInModal}
    />
  );
};
